import type { ReactNode } from "react";
import { Skel } from "../Skel";

// Rows for a `.dtable` inside a flush panel body — the same table, the
// same cell padding, so the real rows replace these without a shift.
// Pass the real column headers when they're known (they are static
// copy, so they render for real); otherwise each header is a bar. The
// first column carries the usual title + sub-line pair. Its px heights
// (12 / 9) are the ones DetalleProyecto and ObservacionesDelProyecto's
// table skeletons already draw — the real cells' line heights — so they
// stay literal; widths are percentages of the cell.
type Props = {
  rows?: number;
  cols: number;
  headers?: ReactNode[];
  compact?: boolean;
};

const WIDTHS = ["60%", "45%", "70%", "40%", "55%"] as const;

export function SkelTable({ rows = 6, cols, headers, compact }: Props) {
  return (
    <div className="panel__body--flush">
      <table className={compact ? "dtable dtable--compact" : "dtable"}>
        <thead>
          <tr>
            {Array.from({ length: cols }, (_, c) => (
              <th key={c} scope="col">
                {headers?.[c] ?? <Skel variant="text" width="50%" />}
              </th>
            ))}
          </tr>
        </thead>
        <tbody aria-hidden="true">
          {Array.from({ length: rows }, (_, r) => (
            <tr key={r}>
              {Array.from({ length: cols }, (_, c) => (
                <td key={c}>
                  {c === 0 ? (
                    <div className="skel-stack">
                      <Skel width="55%" height={12} />
                      <Skel width="35%" height={9} />
                    </div>
                  ) : (
                    <Skel width={WIDTHS[(r + c) % WIDTHS.length] ?? "50%"} height={12} />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
